import { createFileRoute } from "@tanstack/react-router";
import { getCity } from "@/lib/seo/cities";
import { filmproduktionForCity } from "@/lib/seo/localAreaCopy";
import { cityHubRoute } from "@/lib/seo/cityHubRoute";

const city = getCity("ostersund")!;
const page = filmproduktionForCity(city);

export const Route = createFileRoute("/filmproduktion_/ostersund")(cityHubRoute(city, page));
